import React from 'react';
import DynamicCollectionTable from '../components/dynamic/DynamicCollectionTable';

interface DynamicTabContentProps {
    dynamicCollections: any[];
    tabName: string;
}

const DynamicTabContentTable: React.FC<DynamicTabContentProps> = ({ dynamicCollections, tabName }) => {
    const collectionsForTab = dynamicCollections.filter(item => item.tab_name === tabName);

    return (
        <>
            {collectionsForTab.map((collection) => (
                <div key={collection.collection_name} className="mt-4">
                    <DynamicCollectionTable
                        collectionName={collection.collection_name}
                        header={collection.collection_name}
                        eventGroupToTrigger={tabName}
                    />
                </div>
            ))}
        </>
    );
};

export default DynamicTabContentTable;
